module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "front"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_vm._v(_vm._s(_vm.$t("footer.copyright")))])]), _c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('p', {
    staticClass: "policy"
  }, [_c('a', {
    staticClass: "link",
    on: {
      "click": _vm.onTerms
    }
  }, [_vm._v(_vm._s(_vm.$t("footer.terms_of_use")))]), _c('a', {
    staticClass: "link",
    on: {
      "click": _vm.onPolicy
    }
  }, [_vm._v(_vm._s(_vm.$t("footer.policy")))])])]), _c('div', {
    staticClass: "clearfix"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0489bd72","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Front/Footer/index.vue
// module id = 1473
// module chunks = 0